import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { FluxoAprovacaoFiltrosCriteria } from "@workflow/types";

import { fluxoAprovacaoService } from "@/services/api/fluxo-aprovacao.service";

const DETAIL_STALE = 30 * 1000;
const HISTORICO_STALE = 15 * 1000;
const FILTROS_STALE = 30 * 60 * 1000;

/**
 * Query keys do runtime do motor. `all` é prefixo de tudo — inclusive das filas
 * "minhas" de cada processo (ex.: custo-aprovacao.queries reusam este root), então
 * invalidar `all` após uma decisão atualiza todas as filas.
 */
export const fluxoAprovacaoKeys = {
  all: ["fluxo-aprovacao"] as const,
  detail: (id: number) => [...fluxoAprovacaoKeys.all, "detail", id] as const,
  eventos: (id: number) => [...fluxoAprovacaoKeys.all, "eventos", id] as const,
  historicoList: ["fluxo-aprovacao", "historico", "listagem"] as const,
  historicoFiltros: ["fluxo-aprovacao", "historico", "filtros"] as const,
  historicoResumo: () => [...fluxoAprovacaoKeys.all, "historico", "resumo"] as const,
  minhasContagem: () => [...fluxoAprovacaoKeys.all, "minhas", "contagem"] as const,
};

export const fluxoAprovacaoQueries = {
  detail: (id: number) =>
    queryOptions({
      queryKey: fluxoAprovacaoKeys.detail(id),
      queryFn: () => fluxoAprovacaoService.detalhe(id),
      staleTime: DETAIL_STALE,
    }),

  eventos: (id: number) =>
    queryOptions({
      queryKey: fluxoAprovacaoKeys.eventos(id),
      queryFn: () => fluxoAprovacaoService.eventos(id),
      staleTime: DETAIL_STALE,
    }),

  /** Listagem paginada/filtrada do histórico global (server-side, alimenta o DataTable). */
  historicoList: (criteria: FluxoAprovacaoFiltrosCriteria) =>
    queryOptions({
      queryKey: [...fluxoAprovacaoKeys.historicoList, criteria],
      queryFn: () => fluxoAprovacaoService.historicoListagem(criteria),
      placeholderData: keepPreviousData,
      staleTime: HISTORICO_STALE,
    }),

  /** Opções de filtro do histórico global. */
  historicoFiltros: () =>
    queryOptions({
      queryKey: fluxoAprovacaoKeys.historicoFiltros,
      queryFn: () => fluxoAprovacaoService.historicoFiltros(),
      staleTime: FILTROS_STALE,
    }),

  /** KPIs por situação (contagem barata via GROUP BY) — badges das abas. */
  historicoResumo: () =>
    queryOptions({
      queryKey: fluxoAprovacaoKeys.historicoResumo(),
      queryFn: () => fluxoAprovacaoService.historicoResumo(),
      staleTime: HISTORICO_STALE,
    }),
};
